import Skeleton from "@material-ui/lab/Skeleton";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MainCard, ProfileDetailsCard, TextView } from "../../components";
import AiWheelProgressBar from "../../components/AiWheelProgressBar";
import Button from "../../components/Button";
import MainWheel from "../../components/Gallery/MainWheel";
import Navbar from "../../components/Navbar";
import AllBusinessBoxes from "../../components/NewBusinessBox/AllBusinessBoxes";
import BusinessBoxPreview from "../../components/NewBusinessBox/BusinessBoxPreview";
import NewWheelPopup from "../../components/NewWheelPopup";
import wheelTypes from "../../constants/wheelTypes";
import {
  cloneWheel,
  getUserProfileById,
  getUserWheels,
} from "../../services/api";
import {
  useCreateBusinessBoxProfile,
  useGetBusinessBox,
} from "../../services/mutations";
import { useGetPrimaryBusinessBox } from "../../services/queries";
import ToastMessage from "../../sharedcomponents/Toast";
import { colors } from "../../utils";
import { ASSETS, TOAST_TYPE } from "../../utils/config";
import { getLoggedInUser } from "../../utils/helpers";
import { localStorageHelper } from "../../utils/localStorageHelper";
import "./profile.css";
import MobileView from "../Profile/Mobile";
import { isMobile as isMobileDevice } from "react-device-detect";

const OthersProfile = () => {
  const [searchedText, setSearchedText] = useState("");
  const [openWheelPopup, setOpenWheelPopup] = useState(false);
  const [searchedWheels, setSearchedWheels] = useState([]);
  const [userWheels, setUserWheels] = useState([]);
  const [wheelListLoading, setWheelListLoading] = useState(true);
  const [profileData, setProfileData] = useState({});
  const [profileAPiLoading, setProfileAPiLoading] = useState(true);
  const [galleryContent, setGalleryContent] = useState({});
  const [openCloneModal, setOpenCloneModal] = useState(false);
  const [cloneId, setCloneId] = useState(null);
  const [page, setPage] = useState(1);

  const { userid } = useParams();

  useEffect(() => {
    fetchData();
    getBusinessBoxData();
  }, [userid]);

  useEffect(() => {
    localStorageHelper.setAItokenLeft(profileData?.tokens_left);
  }, [profileData]);

  const fetchData = async () => {
    setProfileAPiLoading(true);
    setWheelListLoading(true);

    try {
      const [profileResponse, wheelsResponse] = await Promise.all([
        getUserProfileById(userid),
        getUserWheels(userid),
      ]);

      const profileData = profileResponse.data;
      const wheelsData = wheelsResponse.data;

      setProfileData(profileData);
      setUserWheels(wheelsData.results);
      setProfileAPiLoading(false);
      setWheelListLoading(false);
    } catch (err) {
      console.log(err);
      setProfileAPiLoading(false);
      setWheelListLoading(false);
      setUserWheels([]);
      setProfileData({});
    }
  };

  const handleCloseWheelPopup = () => {
    setOpenWheelPopup(false);
  };

  const handleSearch = (event) => {
    const newValue = event.target.value;
    setSearchedText(newValue);
  };

  const {
    data: primaryBusinessBoxData,
    isLoading: primaryBusinessBoxLoading,
    refetch: refetchPrimaryBusinessBox,
  } = useGetPrimaryBusinessBox(userid || getLoggedInUser()?.id);

  const [isLoadingBusinessBox, setIsLoadingBusinessBox] = useState(
    primaryBusinessBoxLoading
  );
  const [businessBoxes, setBusinessBoxes] = useState([]);
  const [loadMoreBB, setLoadMoreBB] = useState(
    !isEmpty(primaryBusinessBoxData?.data)
  );
  const [selectedBoxCardData, setSelectedBoxCardData] = useState(
    primaryBusinessBoxData?.data
  );
  const [hideFromProfile, setHideFromProfile] = useState(false);

  useEffect(() => {
    setIsLoadingBusinessBox(primaryBusinessBoxLoading);
    setSelectedBoxCardData(primaryBusinessBoxData?.data);
    setHideFromProfile(primaryBusinessBoxData?.data?.is_visible);
    setLoadMoreBB(!isEmpty(primaryBusinessBoxData?.data));
  }, [primaryBusinessBoxLoading, primaryBusinessBoxData]);

  const getBusinessBox = useGetBusinessBox();
  const createProfileBusinessBox = useCreateBusinessBoxProfile();

  const getBusinessBoxData = () => {
    setIsLoadingBusinessBox(true);
    var id = userid || getLoggedInUser()?.id;

    getBusinessBox.mutate(
      { userid: id },
      {
        onSuccess: (response) => {
          if (response?.status === 200) {
            setBusinessBoxes(response?.data?.results);
            setIsLoadingBusinessBox(false);
          }
        },
        onError: (err) => {
          console.log("getBusinessBox Error:::", err);
          setIsLoadingBusinessBox(false);
        },
      }
    );
  };

  const handleBusinessBoxSelect = (business_box, isFirstBbox, isToggle) => {
    setIsLoadingBusinessBox(true);
    createProfileBusinessBox.mutate(business_box, {
      onSuccess: (response) => {
        console.log("SUCCESS:::", response);
        setIsLoadingBusinessBox(false);
        if (isFirstBbox || isToggle) {
          refetchPrimaryBusinessBox();
        }
      },
      onError: (err) => {
        console.log("Error:::", err);
        setIsLoadingBusinessBox(false);
      },
    });
  };

  const handleFirstBbox = (bbox) => {
    handleBusinessBoxSelect(bbox, true);
    setSelectedBoxCardData(bbox);
    setLoadMoreBB(true);
  };

  const handleCloneWheel = async (id) => {
    setCloneId(id);
    try {
      const response = await cloneWheel(id);
      if (response.data.already_cloned) {
        setOpenCloneModal(true);
      } else {
        setMessage("Wheel has been cloned.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const replaceClone = async () => {
    setOpenCloneModal(false);
    try {
      await cloneWheel(cloneId, {
        action: "overwrite",
      });
      setMessage("Previous clone has been replaced");
      setCloneId(null);
    } catch (err) {
      console.log(err);
    }
  };

  const createNewClone = async () => {
    setOpenCloneModal(false);
    try {
      await cloneWheel(cloneId, {
        action: "new",
      });
      setMessage("New clone has been created");
      setCloneId(null);
    } catch (err) {
      console.log(err);
    }
  };

  const [publicWheels, setPublicWheels] = useState([]);
  const [clonedWheels, setClonedWheels] = useState([]);
  const [UnlockWheels, setUnlockWheels] = useState([]);
  const [mainWheel, setMainWheel] = useState(null);

  const publicRef = useRef(null);
  const clonesRef = useRef(null);
  const unlockRef = useRef(null);

  const filterWheels = (wheels) => {
    if (!searchedText) return wheels; // if search text is empty, return all wheels
    return wheels.filter((wheel) =>
      wheel.wheel_name.toLowerCase().includes(searchedText.toLowerCase())
    );
  };

  useEffect(() => {
    if (searchedText) {
      const temp = userWheels.filter((wheel) =>
        wheel.wheel_name.toLowerCase().includes(searchedText.toLowerCase())
      );
      setSearchedWheels(temp);
    }
  }, [searchedText]);

  const isPublic = (wheel) => wheel.is_public === true;
  const isCloned = (wheel) => wheel.is_cloned === true;

  const isUnlockedWheel = (wheel) =>
    wheel.is_locked === false && wheel.user !== getLoggedInUser()?.id;

  useEffect(() => {
    const wheelData = userWheels;

    if (wheelData.length > 0) {
      var index = wheelData.findIndex((wheel) => wheel.is_primary);
      var primaryWheel = index !== -1 ? wheelData[index] : null;
      let otherWheels = wheelData.filter((_, ind) => ind !== index);

      var publicWheelsArray = otherWheels.filter(isPublic);
      var unlockWheelsArray = otherWheels.filter(isUnlockedWheel);
      var clonedWheelsArray = otherWheels.filter(isCloned);

      setMainWheel(primaryWheel);
      setPublicWheels(publicWheelsArray);
      setClonedWheels(clonedWheelsArray);
      setUnlockWheels(unlockWheelsArray);
    }
  }, [userWheels]);

  const scrollToPublic = () => {
    publicRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToClones = () => {
    clonesRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [message, setMessage] = useState("");

  const handleToastCloseCallback = () => {
    setMessage("");
  };

  const renderNoWheelsFound = () => {
    return (
      <div
        style={{
          width: "40vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          margin: "10vh auto",
          marginTop: "10vh",
        }}
      >
        {searchedText ? (
          <>
            <img
              src={ASSETS.noBusinessbox}
              alt="empty"
              style={{
                width: "30%",
              }}
            />
            <h4 style={{ marginTop: "2vh" }}>No wheels found!</h4>
          </>
        ) : (
          <>
            <img
              src={ASSETS.emptyWheel2}
              alt="Create wheel"
              className="img-fluid w-35"
            />
            <TextView
              variant="title"
              style={{ textAlign: "center", marginTop: 40 }}
            >
              There are no public wheels for you to view from this user.
            </TextView>
          </>
        )}
      </div>
    );
  };

  if (!profileAPiLoading && !wheelListLoading & !isMobileDevice)
    return (
      <>
        <div>
          <Navbar />
          {message && (
            <ToastMessage
              message={message || "Some thing went wrong. Please try again"}
              type={TOAST_TYPE.SUCCESS}
              show={true}
              handleCloseCallback={handleToastCloseCallback}
            />
          )}

          {createProfileBusinessBox.isError && (
            <ToastMessage
              message={"Something went wrong, Try again !"}
              type={TOAST_TYPE.ERROR}
            />
          )}
          {createProfileBusinessBox.isSuccess && (
            <ToastMessage
              message={`Business Box has been updated!`}
              type={TOAST_TYPE.SUCCESS}
            />
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#123051",
              position: "sticky",
              top: 0,
            }}
          >
            <div className={`tab`} onClick={scrollToPublic}>
              <img
                src={ASSETS.tabGallery}
                className="img-fluid"
                alt="Gallery"
                width="24"
                height="24"
              />
              Public
            </div>
          </div>
        </div>
        <div
          className="columns-container"
          style={{ overflowY: "auto", height: "calc(100vh - 140px)" }}
        >
          <div className="left-column">
            <div style={{}}>
              <ProfileDetailsCard
                profileImg={profileData?.profile_image}
                name={profileData?.first_name + " " + profileData?.last_name}
                desc={profileData?.bio}
                sub={profileData?.username}
                following={profileData?.followings}
                followers={profileData?.followers}
                editicon={ASSETS.edit}
                shareicon={ASSETS.share}
                facebook={ASSETS.facebook_logo}
                twitter={ASSETS.twitter}
                instagram={ASSETS.instagram}
                isLoading={!profileData && profileAPiLoading}
                profileData={profileData}
                isEditable={false}
              />
            </div>

            <div style={{ marginTop: 20 }}>
              {!!isLoadingBusinessBox && (
                <>
                  <Skeleton
                    variant="rect"
                    width={"90%"}
                    height={150}
                    style={{ borderRadius: "20px", margin: "5%" }}
                  />
                </>
              )}
              {!hideFromProfile ? (
                <>
                  {loadMoreBB ||
                  (!isLoadingBusinessBox && businessBoxes.length === 0) ? (
                    <BusinessBoxPreview
                      isLoading={isLoadingBusinessBox}
                      setIsLoading={setIsLoadingBusinessBox}
                      onlyBusinessBox={true}
                      noBusinessBox={
                        (primaryBusinessBoxData &&
                          isEmpty(primaryBusinessBoxData?.data)) ||
                        (!isLoadingBusinessBox &&
                          businessBoxes.length === 0 &&
                          isEmpty(primaryBusinessBoxData?.data)) || //NEED confirmation => what happens if primaryBusinessBoxData.data doesnt have anything
                        isEmpty(selectedBoxCardData)
                      }
                      businessBoxData={selectedBoxCardData}
                      refetch={refetchPrimaryBusinessBox}
                      handlePopupClick={() => {
                        getBusinessBoxData();
                        setLoadMoreBB(false);
                      }}
                      PopupType={"load"}
                      noEdit={true}
                      handleFirstBbox={handleFirstBbox}
                    />
                  ) : (
                    <AllBusinessBoxes
                      showHeader={false}
                      businessBoxes={businessBoxes}
                      businessBoxApiLoading={isLoadingBusinessBox}
                      refetch={getBusinessBoxData}
                      setOpenPreview={setLoadMoreBB}
                      selectedBoxCardData={selectedBoxCardData}
                      setSelectedBoxCardData={setSelectedBoxCardData}
                      handleBusinessBoxSelect={handleBusinessBoxSelect}
                      isEditable={false}
                    />
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="center-column">
            {wheelListLoading && !userWheels.length ? (
              <Skeleton
                variant="rect"
                width={"90%"}
                height={"70vh"}
                style={{ borderRadius: "20px", margin: "5%" }}
              />
            ) : (
              <>
                <div style={{ marginTop: "20px" }}>
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "rgba(18, 48, 81, 0.5)",
                        },
                      },
                    }}
                    label=""
                    value={searchedText}
                    variant="outlined"
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                      style: {
                        border: "0.2px solid #E1E1E1",
                        borderRadius: "60px",
                        backgroundColor: "white",
                      },
                    }}
                  />
                </div>

                {(searchedText && searchedWheels.length == 0) ||
                (userWheels.length == 0 && !wheelListLoading) ? (
                  renderNoWheelsFound()
                ) : (
                  <>
                    {mainWheel &&
                    (searchedText === "" ||
                      (searchedText.length &&
                        mainWheel.wheel_name
                          .toLowerCase()
                          .includes(searchedText.toLowerCase()))) ? (
                      <MainWheel
                        wheelType={mainWheel?.type}
                        mainName={mainWheel.wheel_name || "Wheel Name"}
                        authorName={"mainWheel?.user_profile?.first_name"}
                        data={mainWheel}
                        isEditable={false}
                        handleCloneWheel={handleCloneWheel}
                      />
                    ) : null}
                    {filterWheels(publicWheels).length ? (
                      <div ref={publicRef}>
                        <MainCard
                          wheelType={wheelTypes.public}
                          wheels={filterWheels(publicWheels)}
                          mainImg={ASSETS.publicDark}
                          name={`Public`}
                          cardTitle={`Wheels`}
                          isPublic={true}
                          isEditable={false}
                          handleCloneWheel={handleCloneWheel}
                        />
                      </div>
                    ) : null}
                  </>
                )}
              </>
            )}
          </div>
          <div className="right-column">
            <div
              style={{
                position: "fixed",
              }}
            >
              <AiWheelProgressBar />
            </div>
          </div>
        </div>
        <Modal
          open={openCloneModal}
          onClose={() => setOpenCloneModal(false)}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <div className="clone-modal">
            <TextView variant="subtitle" style={{ textAlign: "center" }}>
              You've already cloned this Wheel. Would you like to replace your
              previous Clone or create a new one?
            </TextView>
            <div className="clone-button-view">
              <Button
                onClick={replaceClone}
                style={{
                  width: 180,
                  height: 30,
                  fontSize: 12,
                  backgroundColor: colors.background,
                  border: `1px solid ${colors.primary}`,
                  color: colors.darkGrey,
                  marginRight: 10,
                }}
              >
                Replace previous clone
              </Button>
              <Button
                onClick={createNewClone}
                style={{
                  width: 100,
                  height: 30,
                  fontSize: 12,
                }}
              >
                Create New
              </Button>
            </div>
          </div>
        </Modal>
        <NewWheelPopup
          openWheelPopup={openWheelPopup}
          handleCloseWheelPopup={handleCloseWheelPopup}
        />
      </>
    );

  if (isMobileDevice) {
    return (
      <>
        <MobileView
          profileData={profileData}
          businessBoxData={selectedBoxCardData}
          isLoading={profileAPiLoading}
          wheelType={mainWheel?.type}
          mainName={mainWheel?.wheel_name || "Wheel Name"}
          authorName={mainWheel?.user_profile?.first_name}
          data={mainWheel}
          isEditable={false}
          handleCloneWheel={handleCloneWheel}
          publicWheels={filterWheels(publicWheels)}
        />
      </>
    );
  } else <></>;
};

export default OthersProfile;
